import React, { useState, useRef, useEffect } from "react";
import "./education.css";
import AddIcon from "@material-ui/icons/Add";
import WmModals from "../modals/Wm.Modals";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Projectcard from "./Project.card";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import Loading from "../Loading/Loading";
import { useMutation, useQuery, useQueryClient, } from "react-query";
import { addProjectData, getUserDetail } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
const Cookie = new Cookies();
function Project() {
  const queryClient = useQueryClient()
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => { history.push("/login"); };
  const [isEducationModal, setIsEducationModal] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ title: '', description: '', project_url: '', start_date: '', end_date: '', media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy, currently_working: false });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const reset = () => {
    setPortfolioData({ title: '', description: '', project_url: '', start_date: '', end_date: '', media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy, currently_working: false })
  }
  const { isError, isLoading, isSuccess, error } = useQuery(['projectData', 'PROJECT'], getUserDetail, { refetchOnWindowFocus: false, onSuccess: data => { setProjectData(data[0]) } })
  const addProject = useMutation(data => addProjectData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('projectData')
      const previousValue = queryClient.getQueryData('projectData')
      return previousValue
    },
    onError: (previousValue) =>
      queryClient.setQueryData('projectData', previousValue),
    onSuccess: () => {
      queryClient.invalidateQueries('projectData')
      reset();
      setIsEducationModal(false)
    },
  })
  if (isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} /></div></>
  if (isSuccess) return (
    <React.Fragment>
      {token ? (
        <React.Fragment>
          <div className="education container-fluid mb-10 md:mb-0">
            <div className="about_head">
              <span className="block manpro font-semibold text-3xl mb-3">Projects</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {projectData?.map((projectData, idx) => {
                return <Projectcard key={idx} projectData={projectData} />
              })}
            </div>
            <div className="mt-10 text-center flex flex-col items-center">
              <Fab size="small" aria-label="add" className="bg-color-2 color-1 mb-2" onClick={() => setIsEducationModal(true)}>
                <AddIcon />
              </Fab>
              <p className="cursor-pointer inline-block text-sm">Add New</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        backToLoginPage()
      )}
      <WmModals show={isEducationModal} onHide={() => setIsEducationModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Add Project Detail</h5>
        {addProject.isError ? <><div><ServerError message={addProject.error.response.status} /> <div className="text-center manpro mt-4"><Wmbutton label="Cancel" onClick={() => setIsEducationModal(false)} className="rounded w-20 mr-2" type="button" color="primary" /></div> </div></> :
          <form onSubmit={(e) => { e.preventDefault(); addProject.mutate(portfolioData) }}>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Project Title <Required /></label>
              <input placeholder="Project Title" type="text" name="title" required className="wm_form_input border-bottom border-gray-300" value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }} />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Project Link/URL</label>
              <input placeholder="Project Link/URL" type="url" name="course_title" className="wm_form_input border-bottom border-gray-300" value={portfolioData.project_url} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.project_url = e.target.value; return { ...prevData } }) }} />
              <div>
                <small className='manpro text-gray-600'>Please type in the correct URL for the project http://example.com/</small>
              </div>
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Description</label>
              <textarea placeholder="Description" name="description" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} className="wm_form_input border-bottom border-gray-300" onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
              <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
            </div>
            <Row>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Start Date <Required /></label>
                  <DatePicker selected={portfolioData.start_date} onChange={(date) => { setPortfolioData((prevData) => { prevData.start_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  {portfolioData.currently_working ? <span className="manpro font-semibold text-lg text-gray-500">Currently Ongoing</span> : <>
                    <label className="wm_form_label">End Date <Required /></label>
                    <DatePicker selected={portfolioData.end_date} onChange={(date) => { setPortfolioData((prevData) => { prevData.end_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                  </>}
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Project Ongoing</label>
                  <Wmswitch color="success" checked={portfolioData.currently_working} onChange={() => setPortfolioData((prevData) => { prevData.currently_working = !portfolioData.currently_working; return { ...prevData } })} />
                </div>
              </Col>
              <Col md={7}>
                <div className="wm_form_group flex mb-4 items-center">
                  <div className="flex flex-col mr-4">
                    <label className="wm_form_label">Media</label>
                    <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg" />
                    <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                      <img className="object-cover" src={portfolioData.media} alt="education" />
                    </div>
                  </div>
                  <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right">
                    <HelpIcon />
                  </Tooltip>
                </div>
              </Col>
              <Col md={5}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Show Media</label>
                  <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
                </div>
              </Col>
            </Row>
            <div className="wm_form_group">
              <Wmbutton label={addProject.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Save")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
              <Wmbutton label="Cancel" onClick={() => { setIsEducationModal(false); reset() }} className="rounded w-20" type="button" color="primary" />
            </div>
          </form>
        }
      </WmModals>
    </React.Fragment>
  );
}
export default Project;